/*
 * @Description: 本地图层展示框
 * @Author: JokerShaw
 * @Date: 2023-06-14 15:44:51
 * @LastEditTime: 2023-07-19 14:39:25
 * @FilePath: \yd_yg_test_project_new\src\components\GlobeTool\LocalLayerDisplayBox\LocalLayerDisplayBox.js
 */

import React, { Component } from 'react'
import './LocalLayerDosplayBox.css'
import { Checkbox } from 'antd';
import { layerData } from '../data.js'

export default class LocalLayerDisplayBox extends Component {

  constructor(props) {
    super(props)
    this.checkLayerList = new Array(layerData.length).fill('').map(() => new Array(2).fill({}));//临时存储选中的本地图层
    this.state = {
      localLayerList: [],//选中的本地图层
    }
  }

  componentDidMount() {
    // this.switchDisplayBoxVisibleStatus()
  }

  componentDidUpdate(preProps, preState) {
    if (preProps.visible !== this.props.visible) this.setState()
  }

  switchDisplayBoxVisibleStatus = () => {
    if (this.props.visible) {
      document.getElementById("local-layer-display-box-wrap").style.display = "block"
    } else {
      document.getElementById("local-layer-display-box-wrap").style.display = "none"
    }
  }
  // 此处逻辑有问题
  checkLayerMap = (event, layer, index) => {
    // console.log(event.target.checked, layer)
    // console.log("checkLayerMap",window.earth.imageryLayers)
    // console.log("this.checkLayerList", this.checkLayerList)

    if (event.target.checked) {
      // console.log("checkLayerMap",index)
      this.checkLayerList[index][0] = layer.name
      if (layer.type === 'map') {
        // console.log("this.checkLayerList", this.checkLayerList)
        window.earth.imageryLayers._layers[1].show = false
        this.addMapToEarthLayer(layer, index)
      } else if (layer.type === 'wms') {
        window.earth.imageryLayers._layers[1].show = false
        this.addWMTSServerToEarthLayer(layer, index)
      } else if (layer.type === 'terrain') {
        // console.log('terrain')
        // window.earth.imageryLayers._layers[1].show = false
        this.addTerrainToEarthLayer(layer, index)
      }
      this.setState({
        localLayerList: this.checkLayerList
      })
    } else {
      this.checkLayerList[index][0] = ''
      if (layer.type === 'terrain') {
        window.earth.scene.terrainProvider = new window.Geovis.EllipsoidTerrainProvider();
        // window.earth.imageryLayers.remove(this.checkLayerList[index][1])
      } else {
        window.earth.imageryLayers._layers[1].show = true
        window.earth.imageryLayers.remove(this.checkLayerList[index][1])
      }
      this.checkLayerList[index][1] = {}
      // window.earth.imageryLayers._layers[0].show = true
      // window.earth.imageryLayers.remove(this.testImageLayer)
      this.setState({
        localLayerList: this.checkLayerList
      })
    }
  }

  /**
   * @description: 加载基础影像
   * @event: addMapToEarthLayer
   * @return {*}
   */

  addMapToEarthLayer = (layer, index) => {
    console.log("addMapToEarthLayer", index)
    let mapLayer = window.earth.imageryLayers.addImageryProvider(
      new window.Geovis.UrlTemplateImageryProvider({
        url: layer.address
      })
    )
    //  console.log("this.checkLayerList", this.checkLayerList)
    this.checkLayerList[index][1] = mapLayer
    // console.log("addMapToEarthLayer",this.checkLayerList)
  }

  /**
   * @description: 加载WMTS服务
   * @event: addWMTSServerToEarthLayer
   * @return {*}
   */
  addWMTSServerToEarthLayer = (layer, index) => {
    let WMTSLayer = window.earth.imageryLayers.addImageryProvider(
      new window.Geovis.WebMapServiceImageryProvider({
        url: layer.address,
        layers: "day-20230718:trans_dem_3857_rgb",
        parameters: {
          service: 'WMS',
          format: "image/png",
          transparent: true
        },
      })
    )
    this.checkLayerList[index][1] = WMTSLayer
  }
  /**
   * @description: 加载高程服务
   * @event: addTerrainToEarthLayer
   * @return {*}
   */
  addTerrainToEarthLayer = (layer, index) => {
    window.earth.scene.terrainProvider = new window.Geovis.CesiumTerrainProvider({
      url: layer.address,
      credit: "Terrain data courtesy VT MÄK",
    })
    // window.earth.scene.terrainProvider = terrainProvider
    this.checkLayerList[index][1] = window.earth.scene.terrainProvider
  }

  render() {
    const { localLayerList } = this.state
    return (
      <div className="local-layer-display-box-wrap" style={{ display: this.props.visible ? 'block' : 'none' }}>
        {
          layerData.map((layer, index) => {
            return <div key={layer.name} className={!localLayerList.includes(layer.name) ? "local-layer-display-item-wrap" : "local-layer-display-item-wrap-checked"}>
              <Checkbox
                className="local-layer-display-item-checkbox"
                onChange={(event) => { this.checkLayerMap(event, layer, index) }}
              ></Checkbox>
              <div className={!localLayerList.includes(layer.name) ? "local-layer-display-item-name" : "local-layer-display-item-name-checked"}>{layer.name}</div>
            </div>
          })
        }
      </div>
    )
  }
}
